module.exports = __webpack_public_path__ + "static/media/img_Invoice@2x.60311d4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_Invoice@2x.png
// module id = 945
// module chunks = 0